import { useEffect } from "react";

/**
 * Tiny pub/sub for cross-component signup notifications.
 * Used by ExitIntentModal to tell Waitlist a signup completed, so the
 * referral panel renders automatically.
 */
export const SIGNUP_EVENT = "xandi:signup-success";

export const broadcastSignup = (detail) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SIGNUP_EVENT, { detail }));
};

export const useSignupBus = (handler) => {
  useEffect(() => {
    const fn = (e) => handler(e.detail || {});
    window.addEventListener(SIGNUP_EVENT, fn);
    return () => window.removeEventListener(SIGNUP_EVENT, fn);
  }, [handler]);
};
